var _defs, _polygon, _g, _g2, _g3, _g4, _polygon2, _polygon3, _polygon4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripleWide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8b7f6e;\n      }\n\n      .cls-2 {\n        fill: #a09f9f;\n      }\n\n      .cls-3 {\n        fill: #ececec;\n      }\n\n      .cls-4 {\n        fill: #65635f;\n      }\n\n      .cls-5 {\n        fill: #b1b1b0;\n      }\n\n      .cls-6 {\n        fill: #493522;\n      }\n\n      .cls-7 {\n        fill: #76614a;\n      }\n\n      .cls-8 {\n        fill: #3f3e3e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "373.71 786.52 49.3 653.67 741.34 471.88 1030.7 511.35 373.71 786.52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "741.34 319.47 741.34 480.41 745.43 479.28 745.43 319.47 741.34 319.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "737.25 319.47 737.25 478.17 741.34 480.41 741.34 319.47 737.25 319.47"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "741.34 473.38 106.13 642.59 106.13 649.67 741.34 480.47 741.34 473.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "741.34 473.38 106.13 642.59 104.08 638.42 737.25 471.59 741.34 473.38"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "402.27 563.38 406.36 562.72 406.36 397.24 402.27 397.24 402.27 563.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "398.18 561.15 402.27 563.38 402.27 397.24 398.18 398.75 398.18 561.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "481.33 354.67 406.36 397.24 402.27 397.24 477.24 354.67 481.33 354.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "402.43 439.82 402.27 431.76 420.39 386.95 424.52 384.69 402.43 439.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "402.43 439.82 406.36 439.82 428.46 384.69 424.52 384.69 402.43 439.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "398.18 399.81 398.18 395.78 477.24 349.67 477.24 354.67 398.18 399.81"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "974.19 359.94 974.19 518.67 978.28 517.16 978.28 359.94 974.19 359.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "970.11 359.94 970.11 516.43 974.19 518.67 974.19 359.94 970.11 359.94"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "97.95 413.29 209.17 344.28 406.78 338.7 310.65 408.21 106.13 424.78 97.95 413.29"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "92.97 431.06 92.52 422.51 340.53 406.61 336.45 412.33 92.97 431.06"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.97 431.06 389.71 410.17 387.5 406.61 97.95 428.02 92.97 431.06"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "399.68 388.42 136.14 397.44 136.24 394.35 399.79 384.74 399.68 388.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "399.58 391.51 136.04 400.53 136.14 397.44 399.69 387.83 399.58 391.51"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "433.57 364.63 170.03 373.65 170.13 370.56 433.69 360.95 433.57 364.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "433.47 367.72 169.93 376.74 170.03 373.65 433.59 364.04 433.47 367.72"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "693.84 351.56 693.84 486.56 697.93 485.05 697.93 351.56 693.84 351.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "689.75 351.56 689.75 484.32 693.84 486.56 693.84 351.56 689.75 351.56"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "635.14 351.56 635.14 502.25 639.22 500.74 639.22 351.56 635.14 351.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "631.05 351.56 631.05 500.01 635.14 502.25 635.14 351.56 631.05 351.56"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "556.32 351.56 556.32 523.03 560.41 521.52 560.41 351.56 556.32 351.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "552.23 351.56 552.23 520.79 556.32 523.03 556.32 351.56 552.23 351.56"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "483.22 351.56 483.22 542.59 487.31 541.08 487.31 351.56 483.22 351.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "479.14 351.56 479.14 540.35 483.22 542.59 483.22 351.56 479.14 351.56"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "974.19 511.35 391.59 746.98 391.59 754.06 974.19 518.44 974.19 511.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "974.19 511.35 391.59 746.98 389.55 742.82 970.11 509.56 974.19 511.35"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "389.71 513.19 388.28 523.67 353.42 451.05 359.88 451.05 389.71 513.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "389.71 513.19 395.06 514.92 360.2 442.3 359.88 451.05 389.71 513.19"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "391.59 754.06 395.68 752.55 395.68 462.5 391.59 462.5 391.59 754.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "387.5 751.82 391.59 754.06 391.59 462.5 387.5 464.01 387.5 751.82"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "464.67 510.29 463.23 520.77 428.38 448.15 434.84 448.15 464.67 510.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "464.67 510.29 470.01 512.02 435.16 439.4 434.84 448.15 464.67 510.29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "466.55 716.38 470.63 714.87 470.63 459.6 466.55 459.6 466.55 716.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "462.46 714.14 466.55 716.38 466.55 459.6 462.46 461.11 462.46 714.14"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "539.62 481.36 538.19 491.84 503.33 419.21 509.79 419.21 539.62 481.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "539.62 481.36 544.97 483.09 510.11 410.47 509.79 419.21 539.62 481.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "541.5 686.21 545.59 684.7 545.59 430.66 541.5 430.66 541.5 686.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "537.41 683.97 541.5 686.21 541.5 430.66 537.41 432.17 537.41 683.97"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "617.9 454.77 616.47 465.25 581.61 392.63 588.07 392.63 617.9 454.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "617.9 454.77 623.25 456.5 588.39 383.88 588.07 392.63 617.9 454.77"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "619.78 654.71 623.87 653.2 623.87 404.07 619.78 404.07 619.78 654.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "615.69 652.47 619.78 654.71 619.78 404.07 615.69 405.58 615.69 652.47"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "687.38 412.12 699.51 437.38 700.94 426.9 693.84 412.12 687.38 412.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "693.84 412.12 700.94 426.9 706.29 428.63 698.36 412.12 693.84 412.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "702.82 412.12 702.82 620.96 706.9 619.45 706.9 412.12 702.82 412.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "698.73 412.12 698.73 618.72 702.82 620.96 702.82 412.12 698.73 412.12"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "762.84 403 774.97 428.27 776.4 417.79 769.3 403 762.84 403"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "769.3 403 776.4 417.79 781.75 419.52 773.82 403 769.3 403"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "778.28 403 778.28 590.37 782.37 588.86 782.37 403 778.28 403"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "774.19 403 774.19 588.13 778.28 590.37 778.28 403 774.19 403"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "837.22 391.61 849.35 416.87 850.78 406.39 843.69 391.61 837.22 391.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "843.69 391.61 850.78 406.39 856.13 408.12 848.2 391.61 843.69 391.61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "852.66 391.61 852.66 560.45 856.75 558.94 856.75 391.61 852.66 391.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "848.58 391.61 848.58 558.21 852.66 560.45 852.66 391.61 848.58 391.61"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "909 379.92 921.13 405.18 922.56 394.71 915.46 379.92 909 379.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "915.46 379.92 922.56 394.71 927.91 396.44 919.98 379.92 915.46 379.92"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "924.44 379.92 924.44 531.63 928.53 530.12 928.53 379.92 924.44 379.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "920.35 379.92 920.35 529.39 924.44 531.63 924.44 379.92 920.35 379.92"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.51 625.38 177.6 624.71 177.6 419.15 173.51 419.15 173.51 625.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "169.42 623.14 173.51 625.38 173.51 419.15 169.42 420.66 169.42 623.14"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "252.57 376.58 177.6 419.15 173.51 419.15 248.48 376.58 252.57 376.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.67 461.73 173.51 453.68 191.63 408.86 195.76 406.61 173.67 461.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.67 461.73 177.6 461.73 199.7 406.61 195.76 406.61 173.67 461.73"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "169.42 421.73 169.42 417.7 248.48 371.58 248.48 376.58 169.42 421.73"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "249.42 604.11 253.5 603.44 253.5 414.02 249.42 414.02 249.42 604.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "245.33 601.87 249.42 604.11 249.42 414.02 245.33 415.53 245.33 601.87"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "328.48 371.45 253.5 414.02 249.42 414.02 324.39 371.45 328.48 371.45"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "249.58 456.59 249.42 448.54 267.54 403.73 271.67 401.47 249.58 456.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "249.58 456.59 253.5 456.59 275.6 401.47 271.67 401.47 249.58 456.59"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "245.33 416.59 245.33 412.56 324.39 366.45 324.39 371.45 245.33 416.59"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "329.18 583.06 333.27 582.39 333.27 403.49 329.18 403.49 329.18 583.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "325.09 580.82 329.18 583.06 329.18 403.49 325.09 405 325.09 580.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "408.24 360.92 333.27 403.49 329.18 403.49 404.16 360.92 408.24 360.92"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "329.34 446.07 329.18 438.01 347.3 393.2 351.44 390.94 329.34 446.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "329.34 446.07 333.27 446.07 355.37 390.94 351.44 390.94 329.34 446.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "325.09 406.06 325.09 402.03 404.16 355.92 404.16 360.92 325.09 406.06"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "102.04 651.3 106.13 649.7 106.13 417.24 102.04 417.24 102.04 651.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "97.95 648.13 102.04 651.3 102.04 417.24 97.95 418.75 97.95 648.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "181.1 374.67 106.13 417.24 102.04 417.24 177.02 374.67 181.1 374.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "102.2 459.81 102.04 451.76 120.16 406.95 124.3 404.69 102.2 459.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "102.2 459.81 106.13 459.81 128.23 404.69 124.3 404.69 102.2 459.81"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "97.95 419.81 97.95 415.78 177.02 369.67 177.02 374.67 97.95 419.81"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "209.17 341.23 81.93 419.05 82.35 420.24 209.17 342.43 209.17 341.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "209.17 341.23 388.87 462.5 388.87 463.69 209.17 342.43 209.17 341.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "989.22 362.46 388.87 462.5 388.87 463.69 989.22 363.65 989.22 362.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "989.22 362.46 388.87 462.5 209.17 341.23 826.5 293.48 989.22 362.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "209.17 355.04 86.66 431.06 86.66 420.3 209.17 344.28 209.17 355.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "209.17 355.04 388.87 476.07 388.87 465.3 209.17 344.28 209.17 355.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "82.35 420.24 86.66 420.3 209.17 344.28 209.17 342.43 82.35 420.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "86.66 431.06 209.17 355.04 213.08 357.67 92.97 431.06 86.66 431.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "209.17 344.28 209.17 342.43 388.87 463.69 388.87 465.3 209.17 344.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "984.39 371.35 388.87 476.07 388.87 465.3 984.39 366.22 984.39 371.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "984.39 366.22 984.39 364.37 388.87 463.69 388.87 465.3 984.39 366.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "213 340.94 392.28 461.93 405.4 459.74 226.79 339.87 213 340.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.93 339.24 413.91 458.32 427.01 456.14 248.72 338.17 234.93 339.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "256.87 337.54 435.51 454.72 448.61 452.54 270.66 336.48 256.87 337.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "278.82 335.85 457.1 451.13 470.19 448.95 292.6 334.78 278.82 335.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "300.77 334.15 478.67 447.53 491.75 445.35 314.55 333.08 300.77 334.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "322.73 332.45 500.22 443.94 513.29 441.76 336.5 331.38 322.73 332.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "344.7 330.75 521.76 440.35 534.81 438.18 358.46 329.68 344.7 330.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "366.67 329.05 543.27 436.77 556.32 434.59 380.42 327.99 366.67 329.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "388.65 327.35 564.77 433.19 577.8 431.01 402.39 326.29 388.65 327.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "410.63 325.65 586.24 429.61 599.27 427.44 424.37 324.59 410.63 325.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "432.62 323.95 607.7 426.03 620.71 423.87 446.35 322.88 432.62 323.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "454.62 322.25 629.13 422.46 642.13 420.3 468.35 321.18 454.62 322.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "476.62 320.54 650.54 418.89 663.53 416.73 490.34 319.48 476.62 320.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "498.64 318.84 671.93 415.33 684.91 413.17 512.35 317.78 498.64 318.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "520.66 317.14 693.3 411.77 706.26 409.61 534.36 316.08 520.66 317.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "542.68 315.43 714.64 408.21 727.59 406.06 556.38 314.37 542.68 315.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "564.72 313.73 735.96 404.66 748.9 402.51 578.41 312.67 564.72 313.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "586.77 312.02 757.25 401.11 770.18 398.96 600.45 310.96 586.77 312.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "608.82 310.32 778.52 397.57 791.43 395.42 622.5 309.26 608.82 310.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "630.88 308.61 799.77 394.03 812.66 391.88 644.55 307.55 630.88 308.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "652.95 306.9 820.98 390.49 833.86 388.35 666.62 305.84 652.95 306.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "675.03 305.19 842.17 386.96 855.03 384.82 688.69 304.14 675.03 305.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "697.12 303.48 863.33 383.44 876.17 381.3 710.77 302.43 697.12 303.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "719.23 301.77 884.47 379.92 897.29 377.78 732.87 300.72 719.23 301.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "741.34 300.06 905.57 376.4 918.37 374.27 754.97 299.01 741.34 300.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "763.46 298.35 926.64 372.89 939.42 370.76 777.09 297.3 763.46 298.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "785.59 296.64 947.68 369.38 960.44 367.26 799.22 295.59 785.59 296.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "981.43 363.76 821.35 293.87 807.74 294.93 968.69 365.88 981.43 363.76"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.75 383.22 175.32 376.05 238.25 374.67 248.97 381.84 163.75 383.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.75,383.22l85.22-1.38,1.02.69s-80.14,1.91-80.57,1.82-5.67-1.13-5.67-1.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleWide);
export default __webpack_public_path__ + "static/media/Triple-Wide.133edfc26457b451863471e0c658431f.svg";
export { ForwardRef as ReactComponent };